import { createContext } from 'react';
import type { WorkflowContextType } from '@/types/workflow-types';

export const WorkflowContext = createContext<WorkflowContextType | undefined>(undefined);